import { ReduxBaseAction } from '../../domain/redux/ReduxBaseAction';
import { AuthType } from '../../components/enrichment/api/editor/auth/ApiAuthorizationComponent';
import { ApiVariable } from '../../domain/enrichment/EnrichmentDomain';
import { ApiVariableSchema } from '../../domain/enrichment/EnrichmentSchemaDomains';

export type ApiVariableActions =
  | 'CHANGE_API_VARIABLE'
  | 'CHANGE_API_VARIABLE_SCHEMA'
  | 'CHANGE_API_VARIABLE_IS_UPDATE'
  | 'CLEAR_API_VARIABLE'
  | 'CHANGE_API_VARIABLE_AUTH'
  | 'CHANGE_API_VARIABLE_URL'
  | 'CHANGE_API_VARIABLE_DIRTY';

export const changeApiVariable = (payload: ApiVariable | null) =>
  ({
    type: 'CHANGE_API_VARIABLE',
    payload,
  }) as ReduxBaseAction<ApiVariableSchema | null, ApiVariableActions>;

export const changeApiVariableSchema = (payload: ApiVariableSchema | null) =>
  ({
    type: 'CHANGE_API_VARIABLE_SCHEMA',
    payload,
  }) as ReduxBaseAction<ApiVariableSchema | null, ApiVariableActions>;

export const changeIsApiVariableUpdate = (payload: boolean) =>
  ({
    type: 'CHANGE_API_VARIABLE_IS_UPDATE',
    payload,
  }) as ReduxBaseAction<boolean, ApiVariableActions>;

export const clearApiVariable = () =>
  ({
    type: 'CLEAR_API_VARIABLE',
    payload: void 0,
  }) as ReduxBaseAction<any, ApiVariableActions>;

export const changeApiVariableAuth = (payload: AuthType) =>
  ({
    type: 'CHANGE_API_VARIABLE_AUTH',
    payload,
  }) as ReduxBaseAction<any, ApiVariableActions>;

export const changeApiVariableParameter = (payload: ApiVariable) =>
  ({
    type: 'CHANGE_API_VARIABLE_URL',
    payload,
  }) as ReduxBaseAction<any, ApiVariableActions>;

export const changeApiVariableDirty = (payload: boolean) =>
  ({
    type: 'CHANGE_API_VARIABLE_DIRTY',
    payload,
  }) as ReduxBaseAction<any, ApiVariableActions>;
